import { Box, CircularProgress, Grid } from '@mui/material';
import { CreateCampaignHeader } from './CreateCampaignHeader';
import { CampaignLeftSide } from './CampaignLeftSide';
import { CampaignRightSide } from './CampaignRightSide';
import { flexContainerSx } from '../styles/createCampaign';
import { useCampaignData } from '../hooks';
import { stripeLoaderSx } from 'src/common/CommomSxs';

export const CreateCampaign = () => {
  const { shouldShowLoading } = useCampaignData();

  if (shouldShowLoading) {
    return (
      <Grid item xs={12}>
        <Box sx={stripeLoaderSx?.stripeLoaderBx}>
          <CircularProgress size={24} />
        </Box>
      </Grid>
    );
  }

  return (
    <>
      <CreateCampaignHeader />

      <Box sx={flexContainerSx}>
        <CampaignLeftSide />
        <CampaignRightSide />
      </Box>
    </>
  );
};
